module.exports = __webpack_public_path__ + "img/icon-percentage.0e452aaa.svg";